var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.949,
    height: 19.139,
    viewBox: "0 0 15.949 19.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24639054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5257",
    "data-name": "Rectangle 5257",
    width: 15.949,
    height: 19.139,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98435",
    "data-name": "Group 98435",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26991",
    "data-name": "Group 26991",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path-24639054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62599",
    "data-name": "Path 62599",
    d: "M14.313,4.415l-2.778-2.78A5.549,5.549,0,0,0,7.588,0h-3.6A3.992,3.992,0,0,0,0,3.988V15.152a3.992,3.992,0,0,0,3.987,3.987h7.974a3.992,3.992,0,0,0,3.987-3.987V8.362a5.543,5.543,0,0,0-1.636-3.947M13.186,5.543a3.975,3.975,0,0,1,.623.837H10.367a.8.8,0,0,1-.8-.8V2.141a4,4,0,0,1,.838.622Zm1.168,9.609a2.392,2.392,0,0,1-2.392,2.392H3.987a2.392,2.392,0,0,1-2.392-2.392V3.988A2.392,2.392,0,0,1,3.987,1.6h3.6c.131,0,.258.026.387.037v3.95a2.392,2.392,0,0,0,2.392,2.392h3.95c.012.129.037.255.037.387Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsMenuIcon);
export default __webpack_public_path__ + "static/media/documents-menu-icon.5fddff72dca364acdc7badc34aef1783.svg";
export { ForwardRef as ReactComponent };